/**
 * @file Shell around every logged-in page: header, sidebar menu, snackbar and the app-wide dialogs (coaches, busy, server down, refusal).
 * The refusal dialog renders only while `app.refusalDialog` is set; closing it clears that state.
 */
import * as React from "react";
import Component from "../AbstractComponent";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import Constants from "../../Action/Constants";
import Searchbar from "../Partials/Searchbar/Searchbar";
import { NewVersion } from "../Partials/Indicator/NewVersion";
import Breadcrumbs from "../Partials/Breadcrumbs/Breadcrumbs";
import Time from "../../Time/Time";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import LinearProgress from '@material-ui/core/LinearProgress';
import Switch from '@material-ui/core/Switch';
import { PromptDialog } from "../Partials/Dialog/PromptDialog";
import { StepperForNewUser } from "../Partials/Dialog/StepperForNewUser";
import { CoachNewUnitDialog } from "../Partials/Dialog/CoachNewUnitDialog";
import { CoachNewPropertyFirstUserDialog } from "../Partials/Dialog/CoachNewPropertyFirstUserDialog";
import { CoachNewPropertyDialog } from "../Partials/Dialog/CoachNewPropertyDialog";
import { CoachDialog } from "../Partials/Dialog/CoachDialog";
import { CoachNewContractDialog } from "../Partials/Dialog/CoachNewContractDialog";
import { CoachNewAgency } from "../Partials/Dialog/CoachNewAgency";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";
import ChargeCreateDialog from "../Partials/Dialog/ChargeCreateDialog";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import { Admin } from "../../Entity/Entities/Person/Role/Roles/Admin";
import { User } from "../../Entity/Entities/Person/Role/Roles/User";

import Storage from "../../Storage/Storage";

const unitsRootObj = {
  0: '/app/units',
  1: '/app/properties'
}

const financeRootObj = {
  0: '/app/finance/charge',
  1: '/app/finance/payment',
  2: '/app/finance/owner-statements',
  3: '/app/finance/savings',
  4: '/app/finance/reports',
  5: '/app/finance/invoices',
}

const contactsRootObj = {
  0: '/app/contacts/persons',
  1: '/app/contacts/companies'
}

const dashboardRootObj = {
  0: '/app/dashboard/overview',
  1: '/app/dashboard/messages',
  2: '/app/dashboard/statements',
  3: '/app/dashboard/charges',
  4: '/app/dashboard/unused',
  // 4: '/app/dashboard/receivables',
  // 5: '/app/dashboard/payables',
  5: '/app/dashboard/contracts',
  6: '/app/dashboard/tasks',
  7: '/app/dashboard/activities',
  8: '/app/dashboard/notifications',
  9: '/app/coach/new-bill-settlement'
}

class Container extends Component {
  protected sidebarRef;
  protected searchbarRef;

  public state = {
    hovered: false,
    anchorElReminders: null,
    anchorElActions: null,
    openStepperForNewUser: false,
    openCoachCreateNewUnit: false,
    openCoachCreateNewProperty: false,
    propertyCreateByCoach: false,
    openPropertyOwnerCoachDialog: false,
    ownerCreateByCoach: false,
    openPrePropertyOwnerCoachDialog: false,
    ownerType: "company",
    ownerTypeСhose: true,
    openCoachCreateNewContact: false,
    openUnitCoachDialog: false,
    unitCreateByCoach: false,
    openUnitCoachFromContractCoach: false,
    postProcessSignUpPopupOpen: false,
    openUnitCoachDialogForAgencyCoach: false,
    unitCreatedByAgencyCoachScenario: null,
    openCoachNewAgency: false,
    defaultCompanyName: "",
    isChargeCreatePopupOpen: false,
    openNewPropertyFirstUserCoach: false,
    translationSwitcher: false
  }

  constructor(public props) {
    super(props);
    this.sidebarRef = React.createRef();
    this.searchbarRef = React.createRef();
  }

  public componentWillMount() {
    const postProcessMessage = this.props.app.postProcessMessage;
    const users = this.props.app.persons
                    .filter((person: PersonInterface) => !!person &&
                      !person.removed &&
                      !person.createdBySystem &&
                      person.role && 
                      ((person.role.getRoleId() === User.contactRoleId) || (person.role.getRoleId() === Admin.contactRoleId)));
    const postProcessSignUpPopupOpen = !this.props.app?.settings?.user?.finishWelcomeCoach && users?.length === 1;

    if (this.props?.location?.query?.inviteUser){
      this.setState({
        openStepperForNewUser: true,
      })
    }

    this.setState({
      postProcessSignUpPopupOpen: postProcessSignUpPopupOpen
    })

    if (postProcessMessage) {
      this.setState({
        postProcessMessage: postProcessMessage,
        postProcessPopupOpen: true
      });

      this.props.dispatch({
        type: Constants.POST_PROCESS_MESSAGE_CLEAR
      });
    }
    this.setState({
      translationSwitcher: this.props.app.isLanguageKeySwitchOn
  });
  }

  public componentDidMount() {
    document.addEventListener('click', this.hideSideBar, true);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.hideSideBar, false);
  }

  public renderSnackbar = (snackbar): any => {
    return (
      <Snackbar
        className={`snackbar-wrapper ${snackbar.type === "success" ? "hide-close-button" : ""}`}
        open={true}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={snackbar.type === "success" ? this.props.app?.normalSnackbarDelay : this.props.app?.persistentSnackbarDelay}
        onClose={this.closeSnackbar.bind(this, snackbar.id)}
        key={`snackbar-${snackbar.id}`}
        ClickAwayListenerProps={{mouseEvent: false}}
      >
        <MuiAlert
          className="snackbar-alert"
          elevation={6}
          variant="outlined"
          onClose={this.closeSnackbar.bind(this, snackbar.id)}
          severity={snackbar.type}
          key={`alert-${snackbar.id}`}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    )
  }

  protected closeSnackbar = (id) => {
    this.props.dispatch({
      type: Constants.SNACKBAR_REMOVE_MESSAGE,
      payload: {
        id: id
      }
    });
  }

  protected closeAlert = (): any => {
    this.props.dispatch({
      type: Constants.ALERT_HIDE
    });
  }

  protected closeRefusalDialog = (): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_REFUSAL_DIALOG_CLOSE
    });
  }

  public mouseEnter = (): void => {
    this.showSideBar();
    this.setState({
      hovered: true
    });
  }

  public mouseLeave = (): void => {
    this.hideSideBar();
    this.setState({
      hovered: false
    });
  }

  public hideSideBar = (): void => {
    this.sidebarRef?.current?.classList?.remove("hovered");
  }

  public showSideBar = (): void => {
    this.sidebarRef?.current?.classList?.add("hovered");
  }

  public checkPage = (pagesArr, url) => {
    let isPage = false;

    pagesArr.forEach(page => {
      if (page === url) {
        isPage = true;
      }
    });

    return isPage;
  }

  public getIconColor = (menuItem) => {
    const defaultIconStyle = { fill: "#444", color: "#444", position: "relative" as "relative" };
    const activeIconStyle = { fill: "rgb(0, 188, 212)", color: "rgb(0, 188, 212)", position: "relative" as "relative" };

    const url = browserHistory.getCurrentLocation().pathname
      .slice(browserHistory.getCurrentLocation().pathname.indexOf("/app/") + 5);
    const slashPosition = url.indexOf("/") !== -1 ? url.indexOf("/") : url.length;
    const specificUrl = url.slice(0, slashPosition);

    const unitsPages = ["units", "unit", "contract", "properties", "property"];
    const contactsPages = ["contacts", "person", "companies", "company"];
    const financePages = ["finance", "payment", "charge", "owner-statement"];
    const dashboardPages = ["dashboard"];
    const mailPages = ["mails"];

    switch (menuItem) {
      case this.trans("menuitem-units"):
        return this.checkPage(unitsPages, specificUrl) ? activeIconStyle : defaultIconStyle;
      case this.trans("title-contacts"):
        return this.checkPage(contactsPages, specificUrl) ? activeIconStyle : defaultIconStyle;
      case this.trans("title-finance"):
        return this.checkPage(financePages, specificUrl) ? activeIconStyle : defaultIconStyle;
      case this.trans("route-dashboard"):
        return this.checkPage(dashboardPages, specificUrl) ? activeIconStyle : defaultIconStyle;
      case this.trans("mail-box-mail-page"):
        return this.checkPage(mailPages, specificUrl) ? activeIconStyle : defaultIconStyle;
      default:
        break;
    }
  }

  public getReminderEntity = (event: EventInterface) => {
    if (!event) {
      return;
    }

    if (event.chargeId) {
      return {
        icon: "charge",
        entity: "charge",
        id: event.chargeId,
        subtitle: `${event?.charge?.isInvoice && this.trans("title-charge")} for ${event?.charge?.description}`
      };
    }

    if (event.companyId) {
      return {
        icon: "company",
        entity: "company",
        id: event.companyId,
        subtitle: `${this.trans("title-company")} ${event.company && event.company.displayName && event.company.displayName}`
      };
    }

    if (event.contractId) {
      return {
        icon: "contract",
        entity: "contract",
        id: event.contractId,
        subtitle: `${this.trans("title-contract")} for ${event?.contract?.tenantDisplayName}`
      };
    }

    if (event.personId) {
      return {
        icon: "person",
        entity: "person",
        id: event.personId,
        subtitle: !!event.person && `${event.person.firstName} ${event.person.lastName}`
      };
    }

    if (event.propertyId) {
      return {
        icon: "property",
        entity: "property",
        id: event.propertyId,
        subtitle: `${this.trans("title-property")} ${event.property && event.property.address && event.property.address.formattedAddress}`
      };
    }

    if (event.unitId) {
      return {
        icon: "unit",
        entity: "unit",
        id: event.unitId,
        subtitle: `${this.trans("title-unit")} ${event.unit && event.unit.displayName && event.unit.displayName}`
      };
    }

    if (event.paymentId) {
      return {
        icon: "payment",
        entity: "payment",
        id: event.paymentId,
        subtitle: `${this.trans("payment")} for ${!!event.payment && event.payment.description}`
      };
    }

    if (event.refersToEventId) {
      return {
        icon: "info",
        entity: "event",
        id: event.refersToEventId,
        subtitle: `${this.trans("event")}`
      };
    }

    if (event.taskId) {
      return {
        icon: "task",
        entity: "task",
        id: event.taskId,
        subtitle: `${this.trans("task")}`
      };
    }
  }

  protected openMenuReminders = (event: any): void => {
    this.setState({
      anchorElReminders: event.currentTarget
    });
  }

  protected closeMenuReminders = (): void => {
    this.setState({
      anchorElReminders: null
    });
  }


  protected onCloseStepper = () => {
    this.setState({
      openStepperForNewUser: false,
    })
  }

  protected onCloseCoachNewAgency = () => {
    this.props.dispatch({
      type: Constants.POST_PROCESS_SIGN_UP_MESSAGE_CLEAR,
    });

    this.setState({
      openCoachNewAgency: false,
      postProcessSignUpPopupOpen: false,
      openNewPropertyFirstUserCoach: true
    })
  }

  protected openMenuActions = (event: any): void => {
    this.setState({
      anchorElActions: event.currentTarget
    });
  }

  protected closeMenuActions = (): void => {
    this.setState({
      anchorElActions: null
    });
  }

  public clearFinanceFilters = () => {
    this.props.dispatch({
      type: Constants.FINANCE_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.props.dispatch({
      type: Constants.FINANCE_PAYMENTS_FILTER_UPDATE_STATE,
      payload: {
        filter: "all"
      }
    });

    this.props.dispatch({
      type: Constants.FINANCE_PAYMENTS_FILTER_DATE_UPDATE_STATE,
      payload: {
        filter: null
      }
    });

    this.props.dispatch({
      type: Constants.FINANCE_PAYMENTS_FILTER_BANK_ACCOUNT_UPDATE_STATE,
      payload: {
        index: "all"
      }
    });

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_FILTER_UPDATE_STATE,
      payload: {
        filter: "all"
      }
    });

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_FILTER_DATE_UPDATE_STATE,
      payload: {
        filter: null
      }
    });

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.props.dispatch({
      type: Constants.TASK_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.props.dispatch({
      type: Constants.NOTES_FILTER_UPDATE_STATE,
      payload: {
        filter: "all"
      }
    });

    this.props.dispatch({
      type: Constants.NOTES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.props.dispatch({
      type: Constants.NOTIFICATIONS_FILTER_UPDATE_STATE,
      payload: {
        filter: "open"
      }
    });

    this.props.dispatch({
      type: Constants.NOTIFICATIONS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });
  }

  public onCloseUnitCoach = (unit) => {
    this.setState({
      openCoachCreateNewUnit: false,
      propertyCreateByCoach: null,
      unitCreateByCoach: unit,
      openCoachCreateNewContact: this.state.openUnitCoachFromContractCoach ? true : false
    })
  }

  public onCloseNewPropertyFirstUser = () => {
    this.setState({
      openNewPropertyFirstUserCoach: false
    })
  }
  

  public onCloseContractCoach = (contract) => {
    this.setState({
      openCoachCreateNewContact: false,
      unitCreateByCoach: null,
      openUnitCoachFromContractCoach: false,
      unitCreatedByAgencyCoachScenario: null
    });
    if (contract?.id) {
      this.redirect(`/app/contract/update/${contract?.id}`);
    }
  }

  public onClosePropertyCoach = (property) => {
    this.setState({
      openCoachCreateNewProperty: false,
      openCoachCreateNewUnit: true,
      propertyCreateByCoach: property,
      ownerCreateByCoach: null
    })
  }

  public onCloseCoach  = (owner) => {
    this.setState({
      openCoachCreateNewProperty: true,
      openPropertyOwnerCoachDialog: false,
      ownerCreateByCoach: owner,
      defaultCompanyName: ""
    })
  }

  public openFirstStep = () => {
    this.setState({
      openPropertyOwnerCoachDialog: false,
      openPrePropertyOwnerCoachDialog: true,
      // ownerType: "",
      // ownerTypeСhose: false
    })
  }

  public openPropertyCoachDialog = () => {
    this.setState({
      openCoachCreateNewUnit: false,
      openCoachCreateNewProperty: true
    })
  }

  public openCoachNewContract = (unit) => {
    this.setState({
      openCoachCreateNewContact: true,
      unitCreatedByAgencyCoachScenario: unit
    })
  }

  public openPropertyOwnerCoachDialog  = (defaultCompanyName) => {
    this.setState({
      openPrePropertyOwnerCoachDialog: true,
      openCoachCreateNewProperty: false,
      defaultCompanyName: defaultCompanyName
    })
  }

  public openDialogNewPropertyFirstUser = () => {
    this.setState({ 
      postProcessSignUpPopupOpen: false, 
      openNewPropertyFirstUserCoach: true
    });
  }

  public openUnitCoachDialog = () => {
    this.setState({
      openCoachCreateNewUnit: true,
      openCoachCreateNewContact: false,
      openUnitCoachFromContractCoach: true
    })
  }

  public toggleLaunchpanel = () => {
    if (!this.props.app?.settings?.user?.launchPanelState) {
      this.props.dispatch({
        type: Constants.GLOBAL_UNFINISHED_TASKS_COUNT,
      });
    }

    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_START,
      payload: {
        preferences: {
          launchPanelState: !this.props.app?.settings?.user?.launchPanelState,
          userId: this.props.app.session.user.id,
          hideSnackbar: true
        }
      }
    })
  }

  public chooseOwnerType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      ownerType: choice,
      ownerTypeСhose: true
    });
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/propertyowner-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.ownerType}
            onChange={this.chooseOwnerType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/propertyowner-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/propertyowner-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        <div className="hint-styles">
          {this.trans("coach/propertyowner-scenario/company-step/first-info2")}
        </div>
      </div>
    )
  }

  public renderLaunchpanel = () => {
    return (
      <Paper
        className={`launchpanel ${this.props.app?.settings?.user?.launchPanelState ? "show" : ""}`}
      >
        <div
          className="launch-icon-wrapper"
          onClick={this.toggleLaunchpanel}
        >
          {
            !this.props.app?.settings?.user?.launchPanelState && (
              <div
                style={{
                  marginLeft: "2px",
                  cursor: "pointer"
                }}
              >
                <div
                  className="icon icon-ic-keyboard-arrow-left blue-onhover"
                  style={{ fill: "rgb(117, 117, 117)", color: "rgb(117, 117, 117)", position: "relative" as "relative", marginTop: "5px" }}
                ></div>
              </div>
            )
          }
          {
            this.props.app?.settings?.user?.launchPanelState && (
              <div
                style={{
                  marginLeft: "2px",
                  cursor: "pointer"
                }}
              >
                <div
                  className="icon icon-ic-keyboard-arrow-right blue-onhover"
                  style={{ fill: "rgb(117, 117, 117)", color: "rgb(117, 117, 117)", position: "relative" as "relative", marginTop: "5px" }}
                ></div>
              </div>
            )
          }
        </div>
        <div className="launchpanel-header">
          {this.trans("launchpanel-title")}
        </div>
        <div className="item">
          <Link
            onClick={this.openChargeCreatePopup}
          >
            {this.trans("launchpanel-link/register-an-incoming-invoice")}
          </Link>
        </div>
        {
          !!this.props.app?.settings?.agency?.isActivateInvoiceNumber && (
            <div className="item">
              <Link
                onClick={() => this.redirect(`/app/dashboard/statements`)}
              >
                {this.trans("launchpanel-link/send-statements")}
              </Link>
            </div>
          )
        }
        <div className="item">
          <Link
            onClick={() => this.setState({openCoachCreateNewUnit: true})}
          >
            {this.trans("launchpanel-link/createnewunit")}
          </Link>
        </div>
        <div className="item">
          <Link
            onClick={() => {
              this.setState({
                unitCreatedByAgencyCoachScenario: false, unitCreateByCoach: null
              }, () => this.setState({openCoachCreateNewContact: true})
            )}}
          >
            {this.trans("launchpanel-link/createnewcontract")}
          </Link>
        </div>
        <div className="item">
          <Link
            onClick={() => {
              this.setState({
                openNewPropertyFirstUserCoach: true
              })
            }}
          >
            {this.trans("launchpanel-link/newrealestate")}
          </Link>
        </div>
      </Paper>
    );
  }

  public openChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: true
    });
  }

  public closeChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: false
    });
  }

  public handleKeySwitch = async() => {
    let switchValue = await Storage.get("keySwitch");
    const booleanSwitchValue = JSON.parse(switchValue);
    
    if (!booleanSwitchValue) {
        Storage.set("keySwitch", true);
    } else {
        Storage.set("keySwitch", false);
    }

    this.props.dispatch({
      type: Constants.SWITCH_TRANSLATION_KEYS,
      payload: {
        languageKeySwitch: !booleanSwitchValue
      }
    })

    this.setState({
      translationSwitcher: !booleanSwitchValue
    })
  }

  public render() {
    const menuItemStyle = {
      padding: "18px 20px"
    };

    let rootForUnits = unitsRootObj[`${this.props.app.unitsPageTabIndex}`];
    let rootForFinance = financeRootObj[`${this.props.app.financeUpdatePageTabIndex}`];
    let rootForContacts = contactsRootObj[`${this.props.app.contactUpdatePageTabIndex}`];
    let rootForDashboard = dashboardRootObj[`${this.props.app.dashboardUpdatePageTabIndex}`];

    const person = this.props.app.session.user;
    const reminders = this.props.events.reminders;
    const beta = this.props && this.props.app && this.props.app.settings && this.props.app.settings.user && this.props.app.settings.user.beta ? this.props.app.settings.user.beta : false;

    return (
      <div>
        <AppBar
          className="header"
        >
          <Toolbar className="header">
            <div>
              <IconButton onClick={this.mouseEnter}>
                <div className="icon icon-ic-menu"></div>
              </IconButton>

              <div className="logo" style={{cursor: "pointer"}} onClick={() => this.redirect("/app/dashboard/overview")}>{"Casadesk"}</div>
              {this.props.app?.clientAccount && (
                <>
                <FormControlLabel
                  control={
                    <Switch
                        checked={this.state.translationSwitcher}
                        onChange={this.handleKeySwitch}
                        color="primary"
                    />
                  }
                  label={this.trans("button/show-keys")}
                  style={{margin: "0 15px", color: "#000"}}
                />
                <Link
                  onClick={() => this.redirect(`/app/translations`)}
                >
                  Go to Translations
                </Link>
                </>
              )}
            </div>

            <div className="header-searchbar">
              <Searchbar
                className={"global-serch"}
                inputRef={this.searchbarRef}
                {...this.props}
              />

                <div>
                  <div
                    className="notification-bell"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingTop: "4px",
                      margin: "0 20px",
                      width: "auto"
                    }}
                    onClick={e => this.openMenuReminders(e)}
                  >
                    <div
                      className="icon icon-ic-notification"
                    >
                    </div>
                    {reminders.filter(reminder => !reminder.reacted && reminder.event &&
                      (
                        reminder.event.eventTypeId === 35
                        || reminder.event.eventTypeId === 38
                        // || reminder.event.eventTypeId === 17
                      ) &&
                      !reminder.event.removed &&
                      !reminder.event.reacted).length > 0  && (
                        <div className="reminder-counter">{reminders.filter(reminder => !reminder.reacted &&
                          reminder.event &&
                          (
                            reminder.event.eventTypeId === 35
                            || reminder.event.eventTypeId === 38
                            // || reminder.event.eventTypeId === 17
                          ) &&
                          !reminder.event.removed &&
                          !reminder.event.reacted).length}</div>
                      )
                    }
                  </div>

                  <Menu
                    id="simple-menu"
                    anchorEl={this.state.anchorElReminders}
                    open={Boolean(this.state.anchorElReminders)}
                    onClose={this.closeMenuReminders}
                    className="reminder-menu"
                    disableAutoFocusItem={true}
                  >
                    { reminders?.filter(reminder => reminder.event &&
                                          (
                                            reminder.event.eventTypeId === 35
                                            || reminder.event.eventTypeId === 38
                                            // || reminder.event.eventTypeId === 17
                                          ) &&
                                          !reminder.event.removed &&
                                          !reminder.event.reacted)?.length > 0 ?
                      <div
                        style={{
                          padding: "14px 10px 14px 10px",
                          fontSize: "12px", color: "gray",
                          outline: "0",
                          textAlign: "center",
                          userSelect: "none"
                        }}
                      >{this.trans("menuitem-notifications")}</div>
                      :
                      <div
                        style={{
                          padding: "14px 10px 14px 10px",
                          fontSize: "12px", color: "gray",
                          outline: "0",
                          textAlign: "center",
                          userSelect: "none"
                        }}
                      >{this.trans("notifications-not-found")}</div>
                    }
                    {
                      reminders
                      .filter(reminder => reminder.event &&
                                          (
                                            reminder.event.eventTypeId === 35
                                            || reminder.event.eventTypeId === 38
                                            // || reminder.event.eventTypeId === 17
                                          ) &&
                                          !reminder.event.removed &&
                                          !reminder.event.reacted)
                      .map((event: EventInterface, key) => {                        
                        return (
                          <MenuItem
                            key={`reminder-${key}`}
                            className={event.reacted === false ? "unread-reminder" : ""}
                            style={{
                              borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                              height: '70px',
                              display:'flex',
                              alignItems:'center'
                            }}
                            onClick={() => {
                              this.closeMenuReminders();

                              if (!event.reacted && event.creator && this.props.app.session.user.id === event.creator.id) {
                                this.props.dispatch({
                                  type: Constants.GLOBAL_EVENT_UPDATE_START,
                                  payload: {
                                    event: event,
                                    id: event.id,
                                    reacted: true,
                                    content: event.content,
                                  }
                                });
                              }

                              if (event?.event?.eventTypeId === 35 || event?.event?.eventTypeId === 38 ) {
                                return this.redirect(`/app/task/update/${event.refersToEventId}`);
                              }

                              return this.redirect(`/app/note/update/${event.refersToEventId}`);
                            }}
                          >
                            <ListItemIcon>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                  marginTop: "7px",
                                  width: "34px"
                                }}
                              >
                                {event.reacted === false && (
                                  <div style={{width: "5px", height: "5px", margin: "5px 5px 10px 0", borderRadius: "50%", backgroundColor: "red"}}></div>
                                )}
                                <div className={`icon icon-ic-${this.getReminderEntity(event) && this.getReminderEntity(event).icon ? this.getReminderEntity(event).icon : ""}`}></div>
                              </div>
                            </ListItemIcon>
                            <ListItemText>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  paddingTop: "5px",
                                  maxWidth: "300px",
                                  width: "300px",
                                }}>
                                <div
                                  style={{
                                    marginTop: "-8px",
                                    lineHeight: "20px",
                                    overflow: "hidden"
                                  }}
                                >
                                  <div>
                                    <span style={{ fontSize: "13px" }}>{`${event?.event?.eventTypeId === 35 || event?.event?.eventTypeId === 38 ? `${this.trans("task")} reported by ` : ""}`}</span>
                                    <span  
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "13px"
                                      }}
                                    >{`${event.creatorDisplayName}`}</span>                                  
                                  </div>
                                  <div 
                                    style={{
                                      color: "gray",
                                      fontSize: "13px"
                                    }}
                                  >
                                    {event?.content?.name ? event?.content?.name : event?.content?.note}
                                  </div>   
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "gray",
                                    lineHeight: "15px",
                                    overflow: "hidden",
                                    fontWeight: "bold",
                                    paddingTop: "3px"
                                  }}
                                >
                                  {Time.fromNow(event.createdAt)}
                                </div>
                                </div>
                              </div>
                            </ListItemText>
                          </MenuItem>
                        );
                      })
                    }
                  </Menu>
                </div>

              <div style={{display: "flex", flexDirection: "column", marginRight: "10px"}}>
                <div style={{fontSize: "16px", color: "black"}}>{person.firstName} {person.lastName}</div>
                <div className="agency-link" style={{fontSize: "14px", color: "#6d6d6d"}} onClick={() => {this.redirect(`/app/agency/update/${person?.agency?.id}`)}}>{person?.agency?.displayName}</div>
              </div>
              {person.renderAvatar({ backgroundColor: "rgb(232, 232, 232)", size: 45})}

              <div style={{padding: "0 20px 0 10px"}}>
                <IconButton
                  onClick={e => this.openMenuActions(e)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElActions}
                  open={Boolean(this.state.anchorElActions)}
                  onClose={this.closeMenuActions}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      this.closeMenuActions()
                      this.redirect("/app/settings");
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-settings icon-color icon-alingment"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-settings")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.closeMenuActions()
                      this.redirect("/app/new");
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-info icon-color icon-alingment"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-new")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.closeMenuActions()

                      this.props.dispatch({
                        type: Constants.PAGE_SIGNOUT_START
                      });
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-log-out icon-color icon-alingment"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-signout")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <Breadcrumbs {...this.props} />

        <div className="content">
          <Paper
            ref={this.sidebarRef}
            className={this.state.hovered === true ? "sidebar-menu hovered" : "sidebar-menu"}
            onMouseEnter={this.mouseEnter}
            onMouseLeave={this.mouseLeave}
          >
            <MenuItem
              style={menuItemStyle}
              onClick={() => {this.redirect(rootForDashboard); this.mouseLeave();}}
            >
              <ListItemIcon>
                <div className="icon-wrapper">
                  <div className="icon icon-ic-dashboard" style={this.getIconColor(this.trans("menuitem-dashboard"))}></div>
                </div>
              </ListItemIcon>
              <ListItemText>
                {this.trans("title-dashboard")}
              </ListItemText>
            </MenuItem>
            <MenuItem
              style={menuItemStyle}
              onClick={() => {this.redirect(rootForUnits); this.mouseLeave();}}
            >
              <ListItemIcon>
                <div className="icon-wrapper">
                  <div className="icon icon-ic-unit" style={this.getIconColor(this.trans("menuitem-units"))}></div>
                </div>
              </ListItemIcon>
              <ListItemText>
                {this.trans("title-units")}
              </ListItemText>
            </MenuItem>
            <MenuItem
              style={menuItemStyle}
              onClick={() => {this.redirect(rootForContacts); this.mouseLeave();}}
            >
              <ListItemIcon>
                <div className="icon-wrapper">
                  <div className="icon icon-ic-contacts" style={this.getIconColor(this.trans("title-contacts"))}></div>
                </div>
              </ListItemIcon>
              <ListItemText>
                {this.trans("title-contacts")}
              </ListItemText>
            </MenuItem>
            <MenuItem
              style={menuItemStyle}
              onClick={() => {
                // this.clearFinanceFilters();
                this.redirect(rootForFinance);
                this.mouseLeave();
              }}
            >
              <ListItemIcon>
                <div className="icon-wrapper">
                  <div className="icon icon-ic-finances" style={this.getIconColor(this.trans("label-finance"))}></div>
                </div>
              </ListItemIcon>
              <ListItemText>
                {this.trans("title-finance")}
              </ListItemText>
            </MenuItem>
            {
              beta && (
                <MenuItem
                  style={menuItemStyle}
                  onClick={() => {this.redirect('/app/mails'); this.mouseLeave();}}
                >
                  <ListItemIcon>
                    <div className="icon-wrapper">
                      <div className="icon icon-ic-email" style={this.getIconColor(this.trans("mail-box-mail-page"))}></div>
                    </div>
                  </ListItemIcon>
                  <ListItemText>
                    {this.trans("title-mail-box-mail-page")}
                  </ListItemText>
                </MenuItem>
              )}
          </Paper>
          {this.props.children}
        </div>

        <NewVersion
          {...this.props}
          available={this.props.component.newVersionAvailable}
        />

        {
          this.props.app?.snackbars?.length > 0 && this.renderSnackbar(this.props.app?.snackbars?.[0])
        }

        <StepperForNewUser
          {...this.props}
          openStepperForNewUser={this.state.openStepperForNewUser}
          onCloseStepper={this.onCloseStepper}
        />

        <CoachNewAgency
          {...this.props}
          openCoachNewAgency={this.state.postProcessSignUpPopupOpen}
          openDialogNewPropertyFirstUser={this.openDialogNewPropertyFirstUser}
          onCloseCoachNewAgency={this.onCloseCoachNewAgency}
        />

        <CoachNewPropertyFirstUserDialog
          {...this.props}
          openNewPropertyFirstUserCoach={this.state.openNewPropertyFirstUserCoach}
          onCloseNewPropertyFirstUser={this.onCloseNewPropertyFirstUser}
        />   

        <CoachNewUnitDialog
          {...this.props}
          openCoachCreateNewUnit={this.state.openCoachCreateNewUnit}
          onCloseUnitCoach={this.onCloseUnitCoach}
          openPropertyCoachDialog={this.openPropertyCoachDialog}
          openCoachNewContract={this.openCoachNewContract}

          openUnitCoachFromContractCoach={this.state.openUnitCoachFromContractCoach}
          propertyCreateByCoach={this.state.propertyCreateByCoach}
          openUnitCoachDialogForAgencyCoach={this.state.openUnitCoachDialogForAgencyCoach}
        /> 

        <CoachNewPropertyDialog
          {...this.props}
          openCoachCreateNewProperty={this.state.openCoachCreateNewProperty}
          openPropertyOwnerCoachDialog={this.openPropertyOwnerCoachDialog}
          onClosePropertyCoach={this.onClosePropertyCoach}

          ownerCreateByCoach={this.state.ownerCreateByCoach}
        />

        <CoachDialog
          {...this.props}
          openPropertyOwnerCoachDialog={this.state.openPropertyOwnerCoachDialog}
          type={this.state.ownerType}
          defaultCompanyName={this.state.defaultCompanyName}
          onCloseCoach={this.onCloseCoach}
          openFirstStep={this.openFirstStep}
        />

        {this.state.openCoachCreateNewContact &&
        <CoachNewContractDialog
          {...this.props}
          openCoachCreateNewContact={this.state.openCoachCreateNewContact}
          onCloseContractCoach={this.onCloseContractCoach}
          openUnitCoachDialog={this.openUnitCoachDialog}
          unitCreatedByAgencyCoachScenario={this.state.unitCreatedByAgencyCoachScenario}
          unitCreateByCoach={this.state.unitCreateByCoach}
        />
        }

        <ChargeCreateDialog 
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans("title-new-charge")}
          isInvoice={true}
          onCancel={this.closeChargeCreatePopup}
          {...this.props}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/propertyowner-title")}
          innerDialogClasses="coach-owner dialog-assistant"
          content={this.getCoachContent()}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPrePropertyOwnerCoachDialog}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              openPrePropertyOwnerCoachDialog: false,
              openCoachCreateNewProperty: true
              // ownerType: "",
              // ownerTypeСhose: false
            });
          }}
          onSave={() => {this.setState({ openPrePropertyOwnerCoachDialog: false, openPropertyOwnerCoachDialog: true }); }}
          diableContinueButton={!this.state.ownerTypeСhose}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={<p>{this.trans("dialog-agencyisbusy")}</p>}
          positiveButtonLabel={this.trans("button-close")}
          openLeavePrompt={this.props.app.isBusyPopupOpen}
          prioritizeClosing={true}
          onSave={this.closeIsBusyPopup}
          onlyPositiveButton={true}
          hideCross={true}
        />

        {this.props.app.refusalDialog &&
        <PromptDialog
          {...this.props}
          title={this.trans(this.props.app.refusalDialog.titleKey)}
          content={<p>{this.trans(this.props.app.refusalDialog.bodyKey)}</p>}
          positiveButtonLabel={this.trans("button-close")}
          openLeavePrompt={true}
          prioritizeClosing={true}
          onSave={this.closeRefusalDialog}
          onDiscard={this.closeRefusalDialog}
          onlyPositiveButton={true}
        />
        }

        {/* Server down message */}
        <PromptDialog
          {...this.props}
          title={this.trans("title-server-down")}
          content={
            <div>
              <div className="text-container">
                <h4>{this.trans("socket-disconnected-message-line-1")}</h4>
                <p>{this.trans("socket-disconnected-message-line-2")}</p>
                <p>{this.trans("socket-disconnected-message-line-3")}</p>
                <p>{this.trans("socket-disconnected-message-line-4")}</p>
              </div>

              <LinearProgress
                className="progress-bar"
                variant="indeterminate"
              />
            </div>
          }
          openLeavePrompt={this.props.app.socketDisconnected}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
          hideCross={true}
        />

        {/* Alert errors*/}

        <PromptDialog
          {...this.props}
          content={this.props.component.alertMessage === "charge_already_is_fully_paid" ? this.trans("charge_already_is_fully_paid") : this.props.component.alertMessage}
          openLeavePrompt={this.props.component.alertMessage && this.props.component.alertMessage.length > 0}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          actions={[
          <Button
            variant="contained"
            color="primary"
            onClick={this.closeAlert}
          >
            {this.trans("button-close")}
          </Button>]}
          hideCross={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    component: state.container,
    globalTypes: state.globalTypes,
    properties: state.properties,
    units: state.units
  };
};

export default connect(mapStateToProps)(
  Container
);
